import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import initWebVitals from "@/lib/webVitals";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Real-user web-vitals reporter — fire-and-forget. Beacons CLS/LCP/INP/FCP/TTFB
// to /api/web-vitals on tab hide so the Content Health Registry reflects
// p75 field data, not just static HTML evidence.
if (typeof window !== "undefined") {
  try { initWebVitals(); } catch (_) { /* best-effort */ }
}
